import defineCenter from '@/services/general/map/defineCenter';

export default function centerMapGetter(adresse, markers) {
  if (!adresse) return null;
  let adresseCoordone = null;
  if (adresse.latitude && adresse.longitude) {
    adresseCoordone = {
      lat: adresse.latitude === undefined ? adresse.lat : Number(adresse.latitude),
      lng: adresse.longitude === undefined ? adresse.lng : Number(adresse.longitude),
    };
  }
  return defineCenter(markers, adresseCoordone);
}
